<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										DELINQUENCY REPORT
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm ms-5 me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="filterAction"
										:filter="filter"></report-filter>
									<b-button @click="printPDF"
										class="me-2 btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
											:icon="['fas', 'print']" /></b-button>
									<b-button @click="downloadPDF"
										class="btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
											:icon="['fas', 'download']" /></b-button>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row" ref="pdfContent">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution"
										:title="'DELINQUENCY REPORT'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-end">
										<span class="mt-2">Reporting Date:
											<strong>{{ form.end_date }}</strong>
										</span>
									</div>
								</div>
								<div class="col-12 col-md-12 trans_details">
									<b-table id="deliquncy-table" responsive :busy.sync="isBusy" :items="items" :fields="fields"
										:tbody-tr-class="rowClass" show-empty>
										<template #table-busy>
											<div class="text-center text-danger my-2">
												<b-spinner class="align-middle"></b-spinner>
												<strong>Loading...</strong>
											</div>
										</template>
										<template #cell(principal_balance)="data">
											{{ displayNumber(data.item.principal_balance)}} 
										</template>
										<template #cell(savings_balance)="data">
											{{ displayNumber(data.item.savings_balance) }}
										</template>
										<template #cell(net_balance)="data">
											{{ displayNumber((data.item.principal_balance || 0) - (data.item.savings_balance || 0)) }}
										</template>
										<template #cell(one_30_days)="data">{{ displayNumber(data.item.one_30_days)
										}}</template>
										<template #cell(one_3_months)="data">{{ displayNumber(data.item.one_3_months)
										}}</template>
										<template #cell(four_6_months)="data">{{ displayNumber(data.item.four_6_months)
										}}</template>
										<template #cell(seven_9_months)="data">{{
											displayNumber(data.item.seven_9_months) }}</template>
										<template #cell(ten_12_months)="data">{{ displayNumber(data.item.ten_12_months)
										}}</template>
										<template #cell(over_12_months)="data">{{
											displayNumber(data.item.over_12_months) }}</template>
										<template #cell(total_delinquent)="data">
												{{ displayNumber(data.item.total_delinquent) }}
										</template>
										<template #custom-foot>
											<b-tr>
												<b-th colspan="4"></b-th>
												<b-th>Total</b-th>
												<b-th>{{
													displayNumber(
														sumLoanBalance
													)
												}}</b-th>
												<b-th>{{
													displayNumber(
														sumSavingBalance
													)
												}}</b-th>
												<b-th>{{
													displayNumber(
														netBalance
													)
												}}</b-th>
												<b-th>{{ displayNumber(one30days) }}</b-th>
												<b-th>{{ displayNumber(one3Months) }}</b-th>
												<b-th>{{ displayNumber(four6Months) }}</b-th>
												<b-th>{{ displayNumber(seven9Months) }}</b-th>
												<b-th>{{ displayNumber(ten12Months) }}</b-th>
												<b-th>{{ displayNumber(morethan12Months) }}</b-th>
												<b-th>{{ displayNumber(totalDelinquent) }}</b-th>
											</b-tr>
											<b-tr>
												<b-th colspan="4"></b-th>
												<b-th>Grand Total</b-th>
												<b-th>{{displayNumber(grand_total_principal_balance)
												}}</b-th>
												<b-th>{{
													displayNumber(
														grand_total_savings_balance
													)
												}}</b-th>
												<b-th>{{
													displayNumber(
														grand_total_principal_balance - grand_total_savings_balance
													)
												}}</b-th>
												<b-th>{{ displayNumber(grand_total_one_30_days) }}</b-th>
												<b-th>{{ displayNumber(grand_total_one_3_months) }}</b-th>
												<b-th>{{ displayNumber(grand_total_four_6_months) }}</b-th>
												<b-th>{{ displayNumber(grand_total_seven_9_months) }}</b-th>
												<b-th>{{ displayNumber(grand_total_ten_12_months) }}</b-th>
												<b-th>{{ displayNumber(grand_total_over_12_months) }}</b-th>
												<b-th>{{ displayNumber(grand_total_total_delinquent) }}</b-th>
											</b-tr>
										</template>
									</b-table>
								</div>
							</div>
							<div class="row">
								<div class="d-flex justify-content-between px-3">
									<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
										:total-rows="totalRecords" :per-page="perPage"
										aria-controls="member-table"></b-pagination>
									<div class="col text-end mt-1 akkurate-dark">
										<div>{{ currentPage }} - {{ perPage }} of {{ totalRecords }}</div>
										<b-form-group label="Per Page" label-size="sm" class="mb-0">
											<b-form-select @change="selectPerPage" id="per-page-select"
												v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
										</b-form-group>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "../form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			form: {
				start_date: this.getBeginningOfYear(),
				end_date: new Date().toISOString().split("T")[0],
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "Periodic",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				terms: false,
				coa: false,
				voucher_status: false,
				start_date: false,
				end_date: true,
				loan_status: true
			},
			search: "Search",
			isBusy: false,
			isSearching: false,
			selected_num: "10",
			per_page_options: ["10", "20", "50", "100"],
			isLoadingInstitution: false,
			institution: "",
			totalRecords: 0,
			grand_total_principal_balance: 0,
			grand_total_savings_balance: 0,
			grand_total_one_30_days: 0,
			grand_total_one_3_months: 0,
			grand_total_four_6_months: 0,
			grand_total_seven_9_months: 0,
			grand_total_ten_12_months: 0,
			grand_total_over_12_months: 0,
			grand_total_total_delinquent: 0,
			fields: [
				{
					key: "code",
					label: "Cust. Code",
				},
				{
					key: "loan_number",
					label: "Loan #",
				},
				{
					key: "customer_name",
					label: "Customer Name",
				},
				// {
				//   key: "branch",
				//   label: "Branch",
				// },
				{
					key: "mobile",
					label: "Mobile",
				},
				{
					key: "address",
					label: "Address",
				},
				{
					key: "principal_balance",
					label: "Principal Bal(P)",
					tdClass: 'akkurate-lemon-green fw-bold' 
				},
				{
					key: "savings_balance",
					label: "Savings Bal(S)",
					tdClass: 'akkurate-lemon-green fw-bold' 
				},
				{
					key: "net_balance",
					label: "Net Bal(P-S)",
					tdClass: 'akkurate-lemon-green fw-bold' 
				},
				{
					key: "one_30_days",
					label: "1-30 Days",
				},
				{
					key: "one_3_months",
					label: "1-3 Months",
				},
				{
					key: "four_6_months",
					label: "4-6 Months",
				},
				{
					key: "seven_9_months",
					label: "7-9 Months",
				},
				{
					key: "ten_12_months",
					label: "10-12 Months",
				},
				{
					key: "over_12_months",
					label: "Over 12 Months",
				},
				{
					key: "total_delinquent",
					label: "Total Delinquent",
					tdClass: 'akkurate-lemon-green fw-bold' 
				},
			],
			perPage: 20,
			currentPage: 1,
			items: [],
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		sumLoanBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total += this.items[i].principal_balance;
			}
			return total;
		},
		sumSavingBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total += this.items[i].savings_balance || 0;
			}

			return total;
		},
		netBalance() {
			let net_balance = 0;
			for (let i = 0; i < this.items.length; i++) {
				let p = this.items[i].principal_balance || 0;
				let s = this.items[i].savings_balance || 0;
				net_balance += (p - s);
			}
			return net_balance;
		},
		one30days() {
			let one_30_days = 0;
			for (let i = 0; i < this.items.length; i++) {
				one_30_days += this.items[i].one_30_days;
			}
			return one_30_days;
		},
		one3Months() {
			let one_3_months = 0;
			for (let i = 0; i < this.items.length; i++) {
				one_3_months += this.items[i].one_3_months;
			}
			return one_3_months;
		},
		four6Months() {
			let four_6_months = 0;
			for (let i = 0; i < this.items.length; i++) {
				four_6_months += this.items[i].four_6_months;
			}
			return four_6_months;
		},
		seven9Months() {
			let seven_9_months = 0;
			for (let i = 0; i < this.items.length; i++) {
				seven_9_months += this.items[i].seven_9_months;
			}
			return seven_9_months;
		},
		ten12Months() {
			let ten_12_months = 0;
			for (let i = 0; i < this.items.length; i++) {
				ten_12_months += this.items[i].ten_12_months;
			}
			return ten_12_months;
		},
		morethan12Months() {
			let over_12_months = 0;
			for (let i = 0; i < this.items.length; i++) {
				over_12_months += this.items[i].over_12_months || 0;
			}
			return over_12_months;
		},
		totalDelinquent() {
			let total_delinquent = 0;
			for (let i = 0; i < this.items.length; i++) {
				total_delinquent += this.items[i].total_delinquent || 0;
			}
			return total_delinquent;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		}
	},

	created() {
		this.getInstitution();
		this.getAging();
		this.getProductDropdown();
	},
	methods: {
		filterAction() {
			this.getAging();
		},
		rowClass() {
			return "custom-row-height";
		},
		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.getAging();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.getAging();
		},
		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					// console.log(response.data);
					this.isBusy = false;
					this.search = "Search";
					this.form.branch_options = response.data.branches;
				})
				.catch((error) => {
					// console.log(error);
					this.isBusy = false;
					this.search = "Search";
				});
		},
		async getAging() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			const branches = this.form.branches.map((index) => {
				return index.id;
			});
			await ApiService.post("/reports/loans/aging/delinquency", {
				"page": this.currentPage,
				"per_page": this.perPage,
				// "start_date": this.form.start_date,
				"end_date": this.form.end_date,
				"branch": branches,
				"loan_status": this.form.loan_status
			})
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					// console.log(response.data.loans.data);
					var res = response.data.loans.data;
					this.totalRecords = response.data.loans.total
					this.items = res;

					if (response.data.grand_total) {
						let grand_total = response.data.grand_total;
						this.grand_total_principal_balance = grand_total.principal_balance || 0;
						this.grand_total_savings_balance = grand_total.savings_balance || 0;
						this.grand_total_one_30_days = grand_total.one_30_days || 0;
						this.grand_total_one_3_months = grand_total.one_3_months || 0;
						this.grand_total_four_6_months = grand_total.four_6_months || 0;
						this.grand_total_seven_9_months = grand_total.seven_9_months || 0;
						this.grand_total_ten_12_months = grand_total.ten_12_months || 0;
						this.grand_total_over_12_months = grand_total.over_12_months || 0;
						this.grand_total_total_delinquent = grand_total.total_delinquent || 0;
					}
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},
		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		filterTable() {
			this.getAging();
		},
		changePerPageNumber(data) {
			this.perPage = data;
			this.getAging();
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
		// async generateExcel() {
		// 	const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
		// 	const imageUrl = "/default_logo.png"; // Path to your image file

		// 	// Institution details
		// 	const institutionName = this.institution.name;
		// 	const institutionMotto = this.institution.motto;
		// 	const institutionAddress = this.institution.address;
		// 	const institutionPhone = this.institution.telephone;
		// 	const institutionEmail = this.institution.email;

		// 	try {
		// 		// Fetch the Excel file from the public URL
		// 		const response = await fetch(fileUrl);
		// 		if (!response.ok) {
		// 			throw new Error(
		// 				`Network response was not ok: ${response.statusText}`
		// 			);
		// 		}
		// 		const arrayBuffer = await response.arrayBuffer();

		// 		// Load the file into ExcelJS
		// 		const wb = new ExcelJS.Workbook();
		// 		await wb.xlsx.load(arrayBuffer);

		// 		// Access the first sheet
		// 		const ws = wb.getWorksheet(1); // Get the first worksheet

		// 		// Add Image to the top of the sheet
		// 		const imageResponse = await fetch(imageUrl);
		// 		const imageBuffer = await imageResponse.arrayBuffer();
		// 		const imageId = wb.addImage({
		// 			buffer: imageBuffer,
		// 			extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
		// 		});

		// 		// Insert the image at the top-left corner (row 1, column 1)
		// 		ws.addImage(imageId, {
		// 			tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
		// 			ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
		// 		});

		// 		// Insert institution details next to the image (starting at row 1, col 5)
		// 		const institutionDetailsStartCol = 5; // Column where text starts after image
		// 		const institutionDetailsRow = 1; // Row for institution details

		// 		// Add the institution name, address, and phone number
		// 		ws.getCell(`L${institutionDetailsRow}`).value =
		// 			institutionName;
		// 		ws.getCell(`L${institutionDetailsRow}`).font = {
		// 			bold: true,
		// 			size: 14,
		// 		}; // Bold and bigger font for name

		// 		ws.getCell(`L${institutionDetailsRow + 1}`).value =
		// 			institutionAddress;
		// 		ws.getCell(`L${institutionDetailsRow + 1}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for address

		// 		ws.getCell(`L${institutionDetailsRow + 2}`).value =
		// 			institutionMotto;
		// 		ws.getCell(`L${institutionDetailsRow + 2}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		ws.getCell(`L${institutionDetailsRow + 3}`).value =
		// 			institutionPhone;
		// 		ws.getCell(`L${institutionDetailsRow + 3}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		ws.getCell(`L${institutionDetailsRow + 4}`).value =
		// 			institutionEmail;
		// 		ws.getCell(`L${institutionDetailsRow + 4}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		// Optionally adjust the column width if the text is long
		// 		ws.getColumn("K").width = 50; // Adjust the width of column D (if necessary)

		// 		// Define header row
		// 		const header = [
		// 			"Mobile Teller (CRO)",
		// 			"CRO Code",
		// 			"Total Receipts",
		// 			"Branch",
		// 		];

		// 		// Add header row starting from row 13 (or the next row after the image and details)
		// 		const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
		// 		let headerRow = ws.getRow(startingRow);
		// 		headerRow.values = header;
		// 		headerRow.font = { bold: true };
		// 		headerRow.commit(); // Commit the row to the worksheet

		// 		// Add individual data rows
		// 		let currentRow = startingRow + 1;

		// 		// Process each item
		// 		console.log(this.items[0]);
		// 		this.items.forEach((item) => {
		// 			const row = ws.getRow(currentRow);
		// 			// Map item values to the corresponding header columns
		// 			row.values = [
		// 				item.fullname,
		// 				item.coasubhead_code,
		// 				item.total_receipt,
		// 				item.branch,
		// 			];
		// 			row.commit();
		// 			currentRow++;
		// 		});
		// 		const buffer = await wb.xlsx.writeBuffer();
		// 		const blob = new Blob([buffer], {
		// 			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		// 		});

		// 		// Create a download link and simulate a click to download the file
		// 		const link = document.createElement("a");
		// 		link.href = URL.createObjectURL(blob);
		// 		link.download = "Delinquncy_report.xlsx";
		// 		document.body.appendChild(link);
		// 		link.click();
		// 		document.body.removeChild(link);
		// 	} catch (err) {
		// 		console.error(
		// 			"Error fetching, modifying, or downloading the Excel file:",
		// 			err.message
		// 		);
		// 	}
		// },
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const reportTitle = "DELINQUENCY REPORT";
			const reportPeriod = `Reporting Date: ${this.form.end_date}`;
			const branchList = `Branch(es): ${this.branch_list_display}`;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 100, height: 80 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`B${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`B${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`B${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`B${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`B${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`B${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for motto

				ws.getCell(`B${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`B${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`B${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`B${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for email

				// Add report title
				ws.getCell(`B${institutionDetailsRow + 6}`).value = reportTitle;
				ws.getCell(`B${institutionDetailsRow + 6}`).font = {
					bold: true,
					size: 14,
				};

				// Add report period
				ws.getCell(`B${institutionDetailsRow + 7}`).value = reportPeriod;
				ws.getCell(`B${institutionDetailsRow + 7}`).font = {
					size: 12,
				};

				// Add branch list
				ws.getCell(`B${institutionDetailsRow + 8}`).value = branchList;
				ws.getCell(`B${institutionDetailsRow + 8}`).font = {
					size: 12,
				};

				// Define header row matching the table fields
				const header = [
					"Cust. Code",
					"Loan #",
					"Customer Name",
					"Mobile",
					"Principal Bal(P)",
					"Savings Bal(S)",
					"Net Bal(P-S)",
					"1-30 Days",
					"1-3 Months",
					"4-6 Months",
					"7-9 Months",
					"10-12 Months",
					"Over 12 Months",
					"Total Delinquent"
				];

				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 11; // Row after institution details and report info
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FFD3D3D3' } // Light gray background
				};
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.items.forEach((item) => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.code,
						item.loan_number,
						item.customer_name,
						item.mobile,
						item.principal_balance,
						item.savings_balance,
						(item.principal_balance || 0) - (item.savings_balance || 0),
						item.one_30_days,
						item.one_3_months,
						item.four_6_months,
						item.seven_9_months,
						item.ten_12_months,
						item.over_12_months,
						item.total_delinquent
					];
					row.commit();
					currentRow++;
				});

				// Add totals row
				const totalsRow = ws.getRow(currentRow);
				totalsRow.values = [
					"", "", "", "Total",
					this.sumLoanBalance,
					this.sumSavingBalance,
					this.netBalance,
					this.one30days,
					this.one3Months,
					this.four6Months,
					this.seven9Months,
					this.ten12Months,
					this.morethan12Months,
					this.totalDelinquent
				];
				totalsRow.font = { bold: true };
				totalsRow.commit();

				// Add grand totals row
				const grandTotalsRow = ws.getRow(currentRow + 1);
				grandTotalsRow.values = [
					"", "", "", "Grand Total",
					this.grand_total_principal_balance,
					this.grand_total_savings_balance,
					this.grand_total_principal_balance - this.grand_total_savings_balance,
					this.grand_total_one_30_days,
					this.grand_total_one_3_months,
					this.grand_total_four_6_months,
					this.grand_total_seven_9_months,
					this.grand_total_ten_12_months,
					this.grand_total_over_12_months,
					this.grand_total_total_delinquent
				];
				grandTotalsRow.font = { bold: true };
				grandTotalsRow.commit();

				// Auto-fit columns
				ws.columns.forEach(column => {
					let maxLength = 0;
					column.eachCell({ includeEmpty: true }, cell => {
						const length = cell.value ? cell.value.toString().length : 10;
						if (length > maxLength) maxLength = length;
					});
					column.width = maxLength < 10 ? 10 : maxLength > 30 ? 30 : maxLength;
				});

				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Delinquency_Report.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
	},
};
</script>
